export const HOTPADS_COMSCORE_ID = '6036206';
export const HOTPADS_COMSCORE_BEACON_SRC = 'https://sb.scorecardresearch.com/beacon.js';
export const HOTPADS_COMSCORE_PAGEVIEW_PATH = '/api/comscore?comscorekw=rentals';
export const HOTPADS_COMSCORE_PAGEVIEW_CANDIDATE = 'pageview_candidate';
export const HOTPADS_COMSCORE_WINDOW_PARAMS_KEY = '__hotpadsComscoreParams';
